<template>
    <v-data-table
      :headers="headers"
      :items="dataTecnico"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ empresa }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
         
        </v-toolbar>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip class="ma-2">{{ item.estado }}</v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary"> Reset </v-btn>
      </template>
    </v-data-table>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import {
    getAllBitway,
    addBitway,
    updateBitway,
    deleteBitway,
    updateArray,
    deleteArray
  } from "../database.js";
  export default {
    name: "RouterTable",
    props: {   
     empresa: String,
     tecnico: Object
    },
    components: {},
    data: () => ({
      dialog: false,
      dialogDelete: false,
      // ASIGNADO: false,
      headers: [
        {
          text: "Num de Router",
          align: "start",
          sortable: false,
          value: "num_router",
        },
        { text: "Asignado a ", value: "asignado" },
        { text: "Metros de Drop", value: "metros_drop" },
        { text: "Conectores", value: "conectores" },
        { text: "Número de Cliente", value: "num_cliente" },
        { text: "Número de Ticket", value: "num_ticket" },
        { text: "Fecha de asignación", value: "fecha_asignacion" },
        { text: "Fecha de instalación", value: "fecha_instalacion" },
        { text: "Estado", value: "estado", sortable: false },
        { text: "Tipo de trabajo", value: "tipo", sortable: false },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      options: "",
      selectedOption: null,
      selectedOptionTipo: null,
      date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      ).toLocaleDateString(),
      menu: false,
      optionsTipo: [
        { value: "Instalación", text: "Instalación" },
        { value: "Cambio de Tecnología", text: "Cambio de Tecnología" },
        { value: "Servicio técnico", text: "Servicio técnico" },
      ],
      editedIndex: -1,
      namesObject: [],
      editedItem: {
        num_router: "",
        num_cliente: "",
        num_ticket: "",
        metros_drop: "",
        conectores: "",
        asignado: "",
        fecha_asignacion: "",
        fecha_instalacion: "",
        tipo: "",
        estado: "LIBRE",
        id: "",
        idusuario:""      
      },
      defaultItem: {
        num_router: "",
        num_cliente: "",
        num_ticket: "",
        metros_drop: "",
        conectores: "",
        asignado: "",
        fecha_asignacion: "",
        fecha_instalacion: "",
        tipo: "",
        estado: "LIBRE",
  
      },
      iduser:"",
      tipo:"",
      router:"",
      dataTecnico: null,
      mes:null
      
    }),
  
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
      },
      ...mapState({
        userlist: (state) => state.usersList,
        bigwayData: (state) => state.bigwayData,
        bigway: (state) => state.bigway,
        optixData: (state) => state.optixData,
        optix: (state) => state.optix,
        westnetData: (state) => state.westnetData,
        westnet: (state) => state.westnet,
  
  
      }),
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },
  
    async created() {
      // console.log("111", this.userlist);
      // console.log("11", this.date);
      // console.log("11111", this.ASIGNADO);
      // await getAllBitway();
      this.arrayToObject();
      // console.log("optixdata", this.optixData);
      console.log("tecnico", this.tecnico);
      console.log("empresa", this.empresa);
      this.getData();
      this.filterData()
      this.mes=this.date.split("/")[1]
      console.log("mes",this.mes)
    },
  
    methods: {
      editItem(item) {
        // console.log("item para editar", item);
        this.editedIndex = this.bigwayData.indexOf(item);
        console.log("editedIndex", this.editedIndex);
        this.editedItem = Object.assign({}, item);
  
  
  
        this.dialog = true;
      },
  
      deleteItem(item) {
        this.editedIndex = this.optixData.indexOf(item);
        this.editedItem = Object.assign({}, item);
  
        this.dialogDelete = true;
      },
  
      async deleteItemConfirm() {
        // console.log("borrando:", this.editedItem.id);
        await deleteBitway(this.editedItem.id);
        this.bigwayData.splice(this.editedIndex, 1);
        await getAllBitway();
        this.closeDelete();
      },
  
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      async save() {
        if (this.editedIndex > -1) {
          Object.assign(this.bigwayData[this.editedIndex], this.editedItem);
          // console.log("111", this.editedItem);
          // console.log("itemid", this.optixData);
          // console.log("editedItem", this.editedItem);
          this.editedItem.fecha_instalacion = this.date; 
          this.$store.dispatch("setBigwayData", this.editedItem);
          // console.log("optix: ", this.optix);        
          await updateBitway(this.editedItem.id);
          if (this.editedItem.estado === "ASIGNADO") {
            // console.log("userlist",this.userlist)
            let foundObject = this.userlist.find((obj) => obj.iduser === this.editedItem.idusuario);
            console.log(foundObject)
            this.tipo ="en_uso"
            this.router=this.editedItem.num_router
            await updateArray(this.editedItem.idusuario,this.tipo , this.router )
            this.tipo ="libres"
            await deleteArray(this.editedItem.idusuario,this.tipo , this.router )
            if(this.editedItem.tipo === "Instalación"){
              this.tipo = "instalaciones"
              this.router=this.editedItem.num_router
            }
            if(this.editedItem.tipo === "Servicio técnico"){
              this.tipo = "servicio_tecnico"
              this.router=this.editedItem.num_router
            }
            if(this.editedItem.tipo === "Cambio de Tecnología"){
              this.tipo = "cambio_tecnologia"
              this.router=this.editedItem.num_router
            }
            // console.log("tipo: ", this.tipo)
            // console.log("router: ", this.router)
            // console.log(this.editedItem.idusuario)
       
            await updateArray(this.editedItem.idusuario,this.tipo , this.router )
          }
          await getAllBitway();
        } else {       
          this.dialog = true;
          this.editedItem.fecha_asignacion = this.date;
          this.$store.dispatch("setBigwayData", this.editedItem);
          this.tipo = "libres"
          this.router = this.editedItem.num_router
          await updateArray(this.editedItem.idusuario,this.tipo, this.router )
          await addBitway();
          await getAllBitway();
        }
        this.close();
      },
  
      addAsignado(data) {
       
        this.editedItem.asignado = data;
        let name =this.userlist
        let foundObject = name.find((obj) => obj.nombre === data);
        // console.log("asignado: objeto", foundObject.id)
        this.editedItem.idusuario = foundObject.id
        // console.log(this.editedItem.idusuario)
  
      },
     
      addTipo(data) {
        this.editedItem.tipo = data;
        // console.log(this.editedItem.tipo);     
      },
  
      arrayToObject() {
       const names = this.userlist;
        this.namesObject = names.map(user => user.nombre);
        // console.log("edited asignado", this.namesObject)
         
      },
      getData(){
        //segun la empresa , optix , westnet o bigway que me traiga los datos de la tabla
        // console.log("data", this.bigwayData)
        if(this.empresa === "Optix"){
          this.dataTecnico = this.optixData
        }
        if(this.empresa === "Bigway"){
          this.dataTecnico = this.bigwayData
        }
        if(this.empresa === "Westnet"){
          this.dataTecnico = this.westnetData
        }
        
      },
      filterData(){
        //filtrar la data segun el tecnico
        // console.log("tecnico", this.tecnico)
        // console.log("data", this.dataTecnico)
        this.dataTecnico = this.dataTecnico.filter((item) => item.asignado === this.tecnico.nombre)
        //filtrar por mes en curso
        // console.log("data", this.dataTecnico)  
        // this.dataTecnico = this.dataTecnico.filter((item) => item.fecha_instalacion.slice(3, 5) === this.mes)
      }
    },
  };
  </script>